module.exports = __webpack_public_path__ + "static/006551-87bb869a275ee4b708233ae5ce6a6590.jpg";